import React from "react";
import {CHART_HEIGHT} from "./chartTheme";
import "./ChartCard.scss";

export interface ChartCardProps {
  title: string;
  /** One-sentence takeaway shown under the title. */
  takeaway: string;
  children: React.ReactNode;
  /** Optional footnote: sample sizes, marker legend, or caveats. */
  footnote?: React.ReactNode;
  height?: number;
}

// Shared shell for every chart: title + takeaway header, fixed-height container
// (Nivo's Responsive* components measure their parent), and an optional
// footnote. Presentational only; dark mode cascades from the page wrapper.
export default function ChartCard({
  title,
  takeaway,
  children,
  footnote,
  height = CHART_HEIGHT
}: ChartCardProps) {
  return (
    <figure className="fifa-chart-card">
      <figcaption className="fifa-chart-card__header">
        <h3 className="fifa-chart-card__title">{title}</h3>
        <p className="fifa-chart-card__takeaway">{takeaway}</p>
      </figcaption>
      <div className="fifa-chart-card__viz" style={{height}}>
        {children}
      </div>
      {footnote ? (
        <p className="fifa-chart-card__footnote">{footnote}</p>
      ) : null}
    </figure>
  );
}
